export const CREATE_REQUEST_MESSAGE_ENTITY = 'CREATE_REQUEST_MESSAGE_ENTITY'
export const UPDATE_REQUEST_MESSAGE_ENTITY = 'UPDATE_REQUEST_MESSAGE_ENTITY'
export const DELETE_REQUEST_MESSAGE_ENTITY = 'DELETE_REQUEST_MESSAGE_ENTITY'
